import React, { useState, useEffect } from 'react'
import FooterPrime from '../container/Footer/Footer'
import { SB_Header, Navbar, SB_Anecdotas, SB_Timeline, Footer } from '../container'
import { Helmet } from "react-helmet";

const SobreMi = () => {
  const [fontSize, setFontSize] = useState(12); // Tamaño de fuente inicial

  const aumentarTamañoFuente = () => {
    if (fontSize < 16) {
      setFontSize(prevSize => prevSize + 1); // Aumentar el tamaño en 1
    }
  };

  const disminuirTamañoFuente = () => {
    if (fontSize > 9) {
      setFontSize(prevSize => prevSize - 1); // Disminuir el tamaño en 1
    }
  };

  return (
    <div className='App'>
      <Helmet>
        <meta charset="utf-8" />
        <title>Sobre mí - Ricardo Salinas</title>
        <meta name="description" content="Soy un apasionado emprendedor comprometido con el potencial de México. Estoy convencido de la responsabilidad social que tenemos los empresarios." />
      </Helmet>
      <Navbar />
      <SB_Header />
      <SB_Timeline />
      <style>
        {`@media only screen and (max-width: 700px) {
              .SB_movil p {
              font-size: ${fontSize}px !important;
              }
            }`}
      </style>
      <div className='barra_texto_sm_1'>


        <button onClick={disminuirTamañoFuente}>A -</button>
        <button onClick={aumentarTamañoFuente}>A +</button>
      </div>

      <SB_Anecdotas />
      <Footer />
    </div>
  )
}

export default SobreMi
